import { getAllPuzzleData } from "./api/getAllPuzzleData.js";
import "../CSS/table.css";

export async function createTable() {
  const { success, data } = await getAllPuzzleData();

  const chart = document.createElement("div");
  chart.id = "chart";
  document.body.appendChild(chart);

  // select //
  let selectMenu = document.createElement("div");
  selectMenu.classList = "selectTable";
  selectMenu.id = "difficulty";
  selectMenu.name = "size";
  chart.appendChild(selectMenu);

  const options = ["3", "4", "5", "6"];
  options.forEach((option) => {
    const checkboxLabel = document.createElement("label");
    const checkbox = document.createElement("input");
    checkbox.type = "radio";
    checkbox.name = "difficulty";
    checkbox.value = option;

    checkboxLabel.appendChild(checkbox);

    const labelText = document.createElement(`span`);

    switch (option) {
      default:
      case "3":
        labelText.innerText = `Lengvas`;
        checkbox.checked = true;
        break;

      case "4":
        labelText.innerText = `Vidutinis`;
        break;

      case "5":
        labelText.innerText = `Sunkus`;
        break;

      case "6":
        labelText.innerText = `Ekspertas`;
        break;
    }

    checkboxLabel.appendChild(labelText);

    selectMenu.appendChild(checkboxLabel);
  });

  // table //

  const table = document.createElement("table");
  table.id = "res";
  chart.appendChild(table);

  const thead = document.createElement("tr");
  table.appendChild(thead);

  const position = document.createElement("th");
  position.classList = "table-position";
  position.innerText = "#";
  thead.appendChild(position);

  const nickName = document.createElement("th");
  nickName.classList = "table-username";
  nickName.innerText = "Slapyvardis";
  thead.appendChild(nickName);

  const score = document.createElement("th");
  score.classList = "table-score";
  score.innerText = "Rezultatas (paspaudimai)";
  thead.appendChild(score);

  table.getElementsByTagName("tr")[1];

  if (!success) {
    const row = table.insertRow();
    const textCell = row.insertCell();
    textCell.setAttribute("colspan", "3");
    textCell.innerHTML = `${data}`;
    return;
  }

  let number = 1;
  data
    .filter((doc) => doc.difficulty && doc.difficulty["3x3"])
    .sort((a, b) => {
      const aScore = a.difficulty["3x3"].score;
      const bScore = b.difficulty["3x3"].score;
      return aScore - bScore;
    })
    .forEach(function (doc) {
      if (!doc.difficulty["3x3"]) {
        return; // skip user with no score
      }
      const row = table.insertRow();
      const numberCell = row.insertCell();
      const userCell = row.insertCell();
      const scoreCell = row.insertCell();
      numberCell.innerHTML = number;
      userCell.innerHTML = doc.nickname;
      scoreCell.innerHTML = doc.difficulty[`3x3`].score;
      Number(number++);
    });

  selectMenu.addEventListener("change", (event) => {
    const value = event.target.value;

    if (value) {
      let table = document.getElementById("res");
      let rows = table.rows;
      for (let i = rows.length - 1; i > 0; i--) {
        table.deleteRow(i);
      }
      let allUndefined = true;
      for (let i = 0; i < data.length; i++) {
        if (data[i].difficulty[`${value}x${value}`] !== undefined) {
          allUndefined = false;
          break;
        }
      }
      if (allUndefined) {
        const row = table.insertRow();
        const textCell = row.insertCell();
        textCell.setAttribute("colspan", "3");
        textCell.innerHTML = `rezultatu nera`;
        return;
      }
      let number = 1;
      data
        .filter((doc) => doc.difficulty && doc.difficulty[`${value}x${value}`])
        .sort((a, b) => {
          const aScore = a.difficulty[`${value}x${value}`].score;
          const bScore = b.difficulty[`${value}x${value}`].score;
          return aScore - bScore;
        })
        .forEach(function (doc) {
          if (!doc.difficulty[`${value}x${value}`]) {
            return; // skip user with no score
          }
          const row = table.insertRow();
          const numberCell = row.insertCell();
          const userCell = row.insertCell();
          const scoreCell = row.insertCell();
          numberCell.innerHTML = number;
          userCell.innerHTML = doc.nickname;
          scoreCell.innerHTML = doc.difficulty[`${value}x${value}`].score;
          Number(number++);
        });
    }
  });

  // navigation //

  const backToMenu = document.createElement("button");
  backToMenu.innerText = "Grįžti atgal";
  backToMenu.id = "backToMenu";
  backToMenu.classList = "buttonBack";
  chart.appendChild(backToMenu);

  backToMenu.addEventListener("click", () => {
    chart.remove();
    if (document.querySelector("#game")) {
      document.querySelector("#game").style.display = "block";
    } else {
      document.querySelector("#menu").style.display = "flex";
    }
    document.getElementById("authorization").removeAttribute("style");
  });
}

export function drawTable() {
  if (document.querySelector("#game")) {
    document.querySelector("#game").style.display = "none";
  } else {
    document.querySelector("#menu").style.display = "none";
  }
  document.getElementById("authorization").style.display = "none";
  const loading = document.createElement("h1");
  loading.classList = "loading";
  loading.innerText = "kraunama...";
  document.body.appendChild(loading);
  createTable().then(() => {
    loading.remove();
  });
}
